import React from 'react';
import styled from 'styled-components';
import SplitToolbar from 'spark-ui/ui-kitchen/utensils/SplitToolbar';
import ActionSpacer from 'spark-ui/ui-kitchen/utensils/ActionSpacer';

/**
 Details Plate Layout
 ----------------------------------
 | Identifier             Actions |
 |--------------------------------|
 |                                |
 |                                |
 |           Details              |
 |                                |
 |________________________________|
 */

const Layout = ({ identifier, actions, className, children }) => {
    return (
        <div className={className}>
            <SplitToolbar alignment="top">
                <Identifier title={identifier}>{identifier}</Identifier>
                <ActionSpacer>{actions}</ActionSpacer>
            </SplitToolbar>
            <div>{children}</div>
        </div>
    );
};

const Content = styled.div``;

const Identifier = styled.span`
    color: #000;
    text-decoration: none;
    font-size: 20px;
    font-style: normal;

    display: inline-block;
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const detailsPlate = {
    Layout,
    Content
};
export default detailsPlate;
